import Iconify from 'src/components/iconify';
import { BoardAvatar } from 'src/features/board/BoardAvatar';
import { type Board, Table } from 'src/generated/graphql';

export const TablesExplorerLabel = ({ item }: { item: Table | Board }) => {
  return (
    <>
      {'icon' in item ? (
        <BoardAvatar
          icon={item.icon || 'tabler:database'}
          emoji={item.icon || ''}
        />
      ) : (
        <Iconify icon="tabler:table" />
      )}
      <span>{item.name}</span>
    </>
  );
};
